import React, { useCallback, useState } from 'react';

import { Tab, Tabs } from '@material-ui/core';

import EditorField from 'pages/Teachers/shared/EditorField';
import QuestionField from 'pages/Teachers/shared/TranscriptionsAndSolutionsMarkdownField';

import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const LATEX_EDITOR_ENABLED =
  process.env.REACT_APP_LATEX_EDITOR_ENABLED === 'true';

const EditorDialog = ({
  open,
  onClose,
  answer,
  question,
  activeIndex,
  onConfirm,
  onCreate,
  inCreateMode = false
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [currentAnswer, setCurrentAnswer] = useState(answer);
  const [currentQuestion, setCurrentQuestion] = useState(question);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleQuestionChange = useCallback((value) => {
    setCurrentQuestion(value);
  }, []);

  const handleAnswerChange = useCallback((value) => {
    setCurrentAnswer(value);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: styles.dialog }}
      maxWidth="lg"
      showClose={false}
    >
      <Button
        className={styles.completeButton}
        onClick={() => {
          if (activeIndex !== null && !inCreateMode) {
            onConfirm({
              transcription: currentQuestion,
              solution: currentAnswer
            });
          }
          if (inCreateMode) {
            onCreate({
              transcription: currentQuestion,
              solution: currentAnswer
            });
          }
        }}
        disabled={
          (currentQuestion === '' || currentAnswer === '') && inCreateMode
        }
      >
        Confirm
      </Button>
      <Button className={styles.cancelButton} onClick={onClose}>
        Cancel
      </Button>
      <Typography variant="H-TEXT-2" className={styles.header}>
        Edit Content
      </Typography>
      <div className={styles.content}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Question" />
          <Tab label="Answer" />
        </Tabs>
        <div className={styles.tabContent}>
          {LATEX_EDITOR_ENABLED ? (
            <>
              {tabIndex === 0 && (
                <EditorField
                  initialValue={currentQuestion}
                  onChange={handleQuestionChange}
                />
              )}
              {tabIndex === 1 && (
                <EditorField
                  initialValue={currentAnswer}
                  onChange={handleAnswerChange}
                />
              )}
            </>
          ) : (
            <>
              {tabIndex === 0 && (
                <QuestionField
                  initialValue={currentQuestion}
                  onChange={handleQuestionChange}
                />
              )}
              {tabIndex === 1 && (
                <QuestionField
                  initialValue={currentAnswer}
                  onChange={handleAnswerChange}
                />
              )}
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default EditorDialog;
